import { Col, Row } from "react-bootstrap";
import TurnosRouter from "./TurnosRouter";
import { SidebarData } from "../../components/Sidebar/SidebarData";
import { NavLink } from "react-router-dom";
import { AreaTitle } from "../../components/AreaTitle/AreaTitle";
import { BasicCard } from "../../components/BasicCard/BasicCard";

export default function Turnos() {
  const routes = SidebarData.perfilDelPaciente[2].options;

  return (
    <BasicCard
      header={
        <AreaTitle
          addClass="p-3"
          title="Turnos"
        />
      }
    >
      <Row>
        <Col className="switch-container p-3">
          {routes.map((route) => {
            return (
              <NavLink
                key={route.path}
                className="me-2"
                activeClassName="active-switch"
                to={route.path}
              >
                {route.title}
              </NavLink>
            );
          })}
        </Col>
      </Row>
      <TurnosRouter></TurnosRouter>
    </BasicCard>
  );
}
